import { Box, Checkbox, FormControlLabel, FormHelperText, styled } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { ReactElement, ReactNode } from 'react';
import { useField } from 'formik';

export interface PoolFormikCheckboxProps {
    name: string;
    label: ReactNode;
    variant?: 'grey' | 'black';
    disabled?: boolean;
}

const CheckboxLabel = styled(Box)(({ theme }) => ({
    paddingTop: theme.spacing(1.25),
    textAlign: 'left',
}));

export const PoolFormikCheckbox = (props: PoolFormikCheckboxProps): ReactElement => {
    const { name, variant, disabled } = props;
    const [field, meta, fieldHelper] = useField({ name });

    return (
        <>
            <FormControlLabel
                sx={{ m: 0, alignItems: 'center' }}
                control={
                    <Checkbox
                        sx={{
                            color: !!meta.error && meta.touched ? 'error.main' : variant === 'grey' ? 'grey.400' : null,
                            '&:hover': {
                                color: 'common.black',
                            },
                            '&.Mui-checked': {
                                color: 'primary.main',
                            },
                        }}
                        disabled={disabled}
                        checked={field.value}
                        onChange={(_, checked) => fieldHelper.setValue(checked)}
                    />
                }
                label={
                    <CheckboxLabel sx={{ color: theme => (variant === 'grey' ? theme.palette.grey[700] : null) }}>
                        {props.label}
                    </CheckboxLabel>
                }
            />
            <FormHelperText error={meta.touched && !!meta.error} sx={{ alignSelf: 'start', ml: '14px' }}>
                {meta.touched && meta.error && <FormattedMessage id={meta.error} />}
            </FormHelperText>
        </>
    );
};
